const data = [
	{
		'id':1,
		'sochial':'Facebook Page',
		'des':'Contact Us by Our Facebook Page ',
		'btn': <a className="btn btn-outline-primary col-12" href="https://www.facebook.com/saskecompany1/" target="_blank" rel="noreferrer">Click Here</a>,
		'logo':<i className="bi bi-facebook"></i>,
	},
	{
		'id':2,
		'sochial':'whatsapp',
		'des':'now you can communicate with one of our call center crew by whatsapp',
		'btn': <a className="btn btn-outline-success col-12" href="https://api.whatsapp.com/send?phone=201060950140&text='مرحباً توصلت إليكم من خلال معرض أعمال الشركه . هل يمكنكم مساعدتي ؟'" target="_blank" rel="noreferrer">Click Here</a>,
		'logo': <i className="bi bi-whatsapp"></i>,
	},

	{
		'id':3,
		'sochial':'our Channel\'s youtube',
		'des':'you can know more about us by watching our latest projects and lectures on our youtube channel',
		'btn': <a className="btn btn-outline-danger col-12" href="https://www.youtube.com/channel/UCBDkXi6dInbyXJIeofqxrGg" target="_blank" rel="noreferrer">Click Here</a>,
		'logo':<i className="bi bi-youtube"></i>,
	},

	{
		'id':4,
		'sochial':'Linkedin Page',
		'des':'know more about us on our linkedin page',
		'btn': <a className="btn btn-outline-primary col-12" href="https://www.linkedin.com/company/75406561" target="_blank" rel="noreferrer">Click Here</a>,
		'logo':<i className="bi bi-linkedin"></i>,
	},

	{
		'id':5,
		'sochial':'our projects',
		'des':'click on the next button to watch our latest projects',
		'btn': <a className="btn btn-outline-secondary col-12" href="https://github.com/saskecompany" target="_blank" rel="noreferrer">Click Here</a>,
		'logo':<i className="bi bi-github"></i>,
	},

	{
		'id':6,
		'sochial':'call us',
		'des':'click the next button to call us directly by phone',
		'btn': <a className="btn btn-outline-secondary col-12" href="tel:01060950140" target="_blank" rel="noreferrer">Click Here</a>,
		'logo':<i className="bi bi-phone"></i>,
	},

];


export default data;
